import { PropsWithChildren, ReactNode } from "react";
import { InfoTooltip } from "./InfoTooltip.tsx";

export function InputWithLabel({
  children,
  label,
  smallText,
  info,
  rightElement,
}: PropsWithChildren<{
  label: string;
  smallText?: string;
  info?: string;
  rightElement?: ReactNode;
}>) {
  return (
    <div className={"w-full"}>
      <div className={"flex flex-col"}>
        <div className={"flex justify-between space-x-2"}>
          <span className={"flex flex-col mb-2"}>
            <span className={"flex items-center gap-1"}>
              <span className={"font-bold"}>{label}</span>
              {info ? <InfoTooltip text={info} /> : null}
            </span>
            {smallText ? (
              <span className={"text-sm text-slate-600"}>{smallText}</span>
            ) : null}
          </span>
          {rightElement ?? null}
        </div>
        {children}
      </div>
    </div>
  );
}
